import React, { useState } from "react";
import "./BarGraphElement.css";

export default function BarGraphElement(props) {
  const [tooltip, setTooltip] = useState(null);

  const handleMouseEnter = (e) => {
    const rect = e.target.getBoundingClientRect();
    setTooltip({
      top: rect.top - 8,
      left: rect.left + rect.width / 2,
    });
  };
  console.log(props);
  const handleMouseLeave = () => setTooltip(null);

  return (
    <div className="barGraphElementWrapper">
      <div className="barGraphBarContainer">
        <p className="barGraphBarPercentage">{props.primary}%</p>
        <div
          className="barGraphBar"
          style={{
            backgroundColor: "#D1ECF1",
            height: `${props.primary * 1.4}px`,
          }}
        />
      </div>
      <div className="barGraphBarContainer">
        <p className="barGraphBarPercentage">{props.secondary}%</p>
        <div
          className="barGraphBar"
          style={{
            backgroundColor: "#EEEEEE",
            height: `${props.secondary * 1.4}px`,
          }}
        />
      </div>
      <p
        className="barGraphCaseIdText"
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        {props.CaseId}
      </p>
      {tooltip && (
        <div
          className="barGraphTooltip"
          style={{
            top: tooltip.top,
            left: tooltip.left,
          }}
        >
          {props.CaseDignosis}
          <div className="barGraphTooltipArrow" />
        </div>
      )}
    </div>
  );
}
